import { apiGet, apiPatch } from './client';
import type { PriceType, PriceTypeBatchRequest } from '../types/PriceType';

export function getPriceTypes(): Promise<PriceType[]> {
  return apiGet<PriceType[]>('/api/price-types');
}

export function savePriceTypesBatch(
  added: PriceType[],
  modified: PriceType[],
  deletedIds: number[],
): Promise<PriceType[]> {
  return apiPatch<PriceTypeBatchRequest, PriceType[]>('/api/price-types/batch', {
    added,
    modified,
    deleted: deletedIds,
  });
}
